import { render, staticRenderFns } from "./TradeContractInfo.vue?vue&type=template&id=961427cc&scoped=true&"
import script from "./TradeContractInfo.vue?vue&type=script&lang=js&"
export * from "./TradeContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961427cc",
  null
  
)

export default component.exports